/**
 * Which brand this page is being shown as.
 *
 * One app, two front doors:
 *
 *   app.prepworx.io      PrepWorx, with ReturnWorx as one section of it
 *   app.returnworx.com   ReturnWorx only — its own logo, colours and nav, and
 *                        none of the PrepWorx pages
 *
 * Decided by hostname, the same way the warehouse app is (see router). For
 * testing on localhost or a preview URL, add ?brand=returnworx once; it sticks
 * for that browser until ?brand=prepworx.
 */

const OVERRIDE_KEY = 'brand_override'

function readOverride() {
  try {
    const q = new URLSearchParams(window.location.search).get('brand')
    if (q === 'returnworx' || q === 'prepworx') localStorage.setItem(OVERRIDE_KEY, q)
    return localStorage.getItem(OVERRIDE_KEY)
  } catch {
    return null
  }
}

const host = (typeof window !== 'undefined' ? window.location.hostname : '') || ''
const override = typeof window !== 'undefined' ? readOverride() : null

export const isReturnWorxHost =
  override ? override === 'returnworx' : /(^|\.)returnworx\./i.test(host)

export const BRAND = isReturnWorxHost
  ? { key: 'returnworx', name: 'ReturnWorx', themeColor: '#0c0b0a', favicon: '/rw-favicon.png', touchIcon: '/rw-apple-touch-icon.png' }
  : { key: 'prepworx', name: 'PrepWorx', themeColor: '#99835b', favicon: null, touchIcon: null }

/** "ReturnWorx - Account" / "PrepWorx - Dashboard" */
export function pageTitle(title) {
  return `${BRAND.name} - ${title || BRAND.name}`
}

/**
 * Swap the tab icon, theme colour and app name. index.html ships PrepWorx's;
 * this runs before the first route renders.
 */
export function applyBrandToDocument() {
  if (!isReturnWorxHost) return
  const set = (sel, attr, val) => { const el = document.querySelector(sel); if (el) el.setAttribute(attr, val) }
  document.querySelectorAll('link[rel="icon"]').forEach((l) => l.setAttribute('href', BRAND.favicon))
  set('link[rel="apple-touch-icon"]', 'href', BRAND.touchIcon)
  set('link[rel="mask-icon"]', 'color', BRAND.themeColor)
  set('meta[name="theme-color"]', 'content', BRAND.themeColor)
  set('meta[name="application-name"]', 'content', BRAND.name)
  set('meta[name="apple-mobile-web-app-title"]', 'content', BRAND.name)
  document.title = BRAND.name
}

/**
 * Where ReturnWorx clients send inventory. Mirrors RECEIVING in the
 * returnworxAccounts function — the welcome email and the portal must match.
 */
export const RW_RECEIVING = {
  name: 'ReturnWorx',
  address1: '4445 Independence Hwy',
  city: 'Independence',
  state: 'OR',
  zip: '97351',
}
export const rwReceivingCode = (uid) => `RW-${uid || ''}`
